module.exports = __webpack_public_path__ + "030e7e0b164ad395e7125072acda713a.svg";